var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.scope)?_c('tab-list',_vm._l((_vm.scope.children),function(section){return (section.type === "scope_of_works_section")?_c('tab',{key:section.id,attrs:{"name":section.title}},[(section.children.length)?_c('sow-looper',{attrs:{"items":section.children}}):_vm._e()],1):_vm._e()}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }